import { createApp, h } from 'vue';
//import pinia from '@/stores/pinia.js'
import SvgIcon from '@/core/SvgIcon.vue';
import icons from "@/genIcons.js";

export default function createVueWidget(component, element, data) {
    const slots = {};
    const defaultSlotHtml = element.innerHTML;
    slots.default = () => h("div", { class: "vue-slot vue-slot-default", innerHTML: defaultSlotHtml });

    const namedSlots = element.querySelectorAll('[data-vue-slot]');
    namedSlots.forEach(async (element) => {
        const slotName = element.dataset["vueSlot"];
        const className = slotName.replace(/\s+/g, '-').toLowerCase(); // TODO сделать более сложное преобразование из camelCase или PascalCase в cebab-case
        const slotHtml = element.innerHTML;
        slots[slotName] = () => h("div", { class: "vue-slot vue-slot-named vue-slot-" + className, innerHTML: slotHtml });
    });

    delete data.widget;

    const app = createApp({
        render() {
            return h(component, data, slots)
        }
    });

    //app.use(pinia);

    // Добавление mixin для работы с строками
    app.mixin({
        methods: {
            $s(name) {
                return (window.cms_strings || {})[name] || "";
            },
        },
    });

    // Добавление mixin для работы со значениями
    app.mixin({
        methods: {
            $v(name) {
                return (window.cms_values || {})[name] || "";
            },
        },
    });

    app.mixin({
        methods: {
            $icon(name) {
                return icons[name];
            },
        },
    });

    app.mixin({
        methods: {
            $numberFormat(value) {
                return parseFloat(value).toLocaleString("ru");
            },
        },
    });

    app.component('SvgIcon', SvgIcon);
    app.mount(element);
}
